import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { usePortal } from '../../contexts/PortalContext';
import { BUTTON_GHOST, BUTTON_QUIET, BUTTON_SOLID, FIELD } from './adminStyles';
export function PortalTeam() {
  const {
    activeProject,
    addTeamMember,
    updateTeamMember,
    removeTeamMember,
    notify
  } = usePortal();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!name.trim()) return;
    addTeamMember({
      name: name.trim(),
      role: role.trim() || 'Crew'
    });
    notify(`${name.trim()} assigned`);
    setName('');
    setRole('');
    setOpen(false);
  }
  return <section aria-labelledby="portal-team" className="mt-16" data-id="element-271" data-mp="2awkjbcoxh1mw">
      <div className="flex flex-wrap items-baseline justify-between gap-4 border-b border-ruleDark pb-4" data-id="element-272" data-mp="14ha3m15gb8j2">
        <h2 id="portal-team" className="label m-0 text-paper/40" data-id="element-273" data-mp="zhxh5hihs3h0">
          Portal Team
        </h2>
        <p className="label-sm m-0 text-paper/35" data-id="element-274" data-mp="2dzg8ob74e61q">Responsibility only · internal</p>
      </div>

      <ul className="m-0 list-none p-0" data-id="element-275" data-mp="2iysx30dn3l6f">
        {activeProject.team.length === 0 && <li className="border-b border-ruleDark py-8 font-display text-xl text-paper/40" data-id="element-276" data-mp="24zjpuq7ew1el">
            No team assigned yet.
          </li>}
        {activeProject.team.map(member => <li key={member.id} className="flex flex-wrap items-center justify-between gap-x-8 gap-y-4 border-b border-ruleDark py-6" data-id="element-277" data-mp="1v9gkdqj3suzd">
            <p className="min-w-0 flex-1 font-display text-2xl leading-none" data-id="element-278" data-mp="201hylhzu0vs1">{member.name}</p>
            <label className="min-w-[12rem]" data-id="element-279" data-mp="1mamt8fojkwt7">
              <span className="sr-only" data-id="element-280" data-mp="1q9vmzkjl0uor">Role for {member.name}</span>
              <input value={member.role} onChange={event => updateTeamMember(member.id, {
            role: event.target.value
          })} className={`${FIELD} mt-0`} data-id="element-281" data-mp="1q810i1snwuik" />
            </label>
            <button type="button" onClick={() => removeTeamMember(member.id)} className={BUTTON_QUIET} data-id="element-282" data-mp="3izehjrh3sux0">
              Remove
            </button>
          </li>)}
      </ul>

      {open ? <form onSubmit={submit} className="mt-8 flex flex-col gap-8 sm:flex-row sm:items-end" data-id="element-283" data-mp="3a4gkc86xavzv">
          <label className="flex-1" data-id="element-284" data-mp="359az7blchlcu">
            <span className="label block text-paper/40" data-id="element-285" data-mp="5s2xcgtd74ra">Name</span>
            <input value={name} onChange={event => setName(event.target.value)} placeholder="e.g. Tom Smith" autoFocus className={FIELD} data-id="element-286" data-mp="5q8mjvbt4t0x" />
          </label>
          <label className="flex-1" data-id="element-287" data-mp="3nyhcgj3ddkr9">
            <span className="label block text-paper/40" data-id="element-288" data-mp="3nxfx42fbmc3q">Role</span>
            <input value={role} onChange={event => setRole(event.target.value)} placeholder="e.g. Project Lead" className={FIELD} data-id="element-289" data-mp="2hi5kizr54z44" />
          </label>
          <div className="flex items-center gap-6" data-id="element-290" data-mp="22g6u6bjzwuq7">
            <button type="submit" className={BUTTON_SOLID} data-id="element-291" data-mp="27dyo1b47aqx1">
              Assign
            </button>
            <button type="button" onClick={() => setOpen(false)} className={BUTTON_QUIET} data-id="element-292" data-mp="2cd1pklkz2f09">
              Cancel
            </button>
          </div>
        </form> : <button type="button" onClick={() => setOpen(true)} className={`${BUTTON_GHOST} mt-8 inline-flex items-center gap-3`} data-id="element-293" data-mp="2h5uyllnh49i5">
          <PlusIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-294" data-mp="2q357j0ctjmjw" />
          Assign Team Member
        </button>}
    </section>;
}